// Widths of the session side panel's content, per layout. In a screen width of 1440px,
// the split side panel is 965px + 32px padding.
//
// Measured against the session row, an `@container`, rather than the panel: the panel's
// box opens and closes around its content (`PanelReveal`), and a percentage would shrink
// with it and re-wrap the content on every frame. Each share leaves out the gutter the
// panel keeps beside the chat, `PanelReveal`'s gap, so panel and gutter add up to it.
export const SIDE_PANEL_SPLIT_WIDTH_CLASS_NAME = 'w-[calc(69.24cqw_-_var(--space-app-inset))]';
export const SIDE_PANEL_FULLSCREEN_WIDTH_CLASS_NAME = 'w-[100cqw]';

// Interview layout: personas panel (~568px / 39.44%) beside the chat.
export const INTERVIEW_PANEL_WIDTH_CLASS_NAME = 'w-[calc(39.44cqw_-_var(--space-app-inset))]';
